export default "__VITE_ASSET__CgLfaLm___"